/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type MerchantNames_storeLists$ref = any;
export type CreateMerchantNameInput = {|
  clientMutationId?: ?string,
  name: string,
  storeId: string,
|};
export type createMerchantNameMutationVariables = {|
  input: CreateMerchantNameInput,
  storeId: string,
|};
export type createMerchantNameMutationResponse = {|
  +createMerchantName: ?{|
    +storeLists: ?{|
      +$fragmentRefs: MerchantNames_storeLists$ref
    |},
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type createMerchantNameMutation = {|
  variables: createMerchantNameMutationVariables,
  response: createMerchantNameMutationResponse,
|};
*/


/*
mutation createMerchantNameMutation(
  $input: CreateMerchantNameInput!
  $storeId: ID!
) {
  createMerchantName(input: $input) {
    storeLists {
      ...MerchantNames_storeLists
      id
    }
    errors {
      key
      messages
    }
  }
}

fragment MerchantNames_storeLists on StoreLists {
  id
  merchantNames(storeId: $storeId) {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateMerchantNameInput!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId",
    "type": "ID!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createMerchantNameMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateMerchantNamePayload",
        "kind": "LinkedField",
        "name": "createMerchantName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreLists",
            "kind": "LinkedField",
            "name": "storeLists",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "MerchantNames_storeLists"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createMerchantNameMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateMerchantNamePayload",
        "kind": "LinkedField",
        "name": "createMerchantName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreLists",
            "kind": "LinkedField",
            "name": "storeLists",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "storeId",
                    "variableName": "storeId"
                  }
                ],
                "concreteType": "MerchantName",
                "kind": "LinkedField",
                "name": "merchantNames",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createMerchantNameMutation",
    "operationKind": "mutation",
    "text": "mutation createMerchantNameMutation(\n  $input: CreateMerchantNameInput!\n  $storeId: ID!\n) {\n  createMerchantName(input: $input) {\n    storeLists {\n      ...MerchantNames_storeLists\n      id\n    }\n    errors {\n      key\n      messages\n    }\n  }\n}\n\nfragment MerchantNames_storeLists on StoreLists {\n  id\n  merchantNames(storeId: $storeId) {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f2ce700aca54ff6431af93a3dc15bf46';

module.exports = node;
